import SystemPage from "@/components/feature/SystemPage";

export default function MaintenancePage() {
  return (
    <SystemPage
      code="Maintenance"
      icon="ri-tools-line"
      title="Maintenance en cours"
      description="La plateforme est momentanément indisponible pour une opération de maintenance. Nous revenons très vite — merci de votre patience."
      primaryLabel="Retour à l'accueil"
      primaryTo="/"
      secondaryLabel="Nous contacter"
      secondaryTo="/contact"
      tone="maintenance"
    />
  );
}